'use client';

import { motion } from 'framer-motion';
import { Shield, Truck, Users, Award } from 'lucide-react';
import { useDesign } from '@/context/DesignContext';

interface TrustBarProps {
  benefits?: Array<{
    icon: string;
    title: string;
    description: string;
  }>;
  design?: any;
  style?: React.CSSProperties; // <-- added
}

const iconMap: Record<string, React.ElementType> = {
  Shield,
  Truck,
  Users,
  Award,
};

export function TrustBar({
  benefits = [
    { icon: 'Shield', title: 'Authentique', description: 'Produits certifiés' },
    { icon: 'Truck', title: 'Express', description: 'Livraison 24H' },
    { icon: 'Users', title: 'Conseils', description: 'Experts diplômés' },
    { icon: 'Award', title: 'Qualité', description: 'Sélection premium' }
  ],
  design: propDesign,
  style, // <-- added
}: TrustBarProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const bgColor = design?.componentDesignMap?.TrustBar?.sectionBackground || design?.colors?.backgroundAlt || '#F8FAFC';
  const borderColor = design?.componentDesignMap?.TrustBar?.borderColor || design?.colors?.border || '#E2E8F0';
  const iconBg = design?.componentDesignMap?.TrustBar?.iconBackground || '#FFFFFF';
  const iconColor = design?.componentDesignMap?.TrustBar?.iconColor || design?.colors?.text || '#0F172A';
  const titleColor = design?.componentDesignMap?.TrustBar?.titleColor || design?.colors?.text || '#0F172A';
  const descColor = design?.componentDesignMap?.TrustBar?.descriptionColor || design?.colors?.textLight || '#64748B';

  return (
    <section
      className="py-8 border-y"
      style={{ background: bgColor, borderColor: borderColor, ...style }} // <-- merged
    >
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon] || Shield;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center gap-4"
              >
                <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-sm" style={{ background: iconBg }}>
                  <IconComponent className="w-6 h-6" style={{ color: iconColor }} />
                </div>
                <div>
                  <p className="font-semibold" style={{ color: titleColor }}>{benefit.title}</p>
                  <p className="text-sm" style={{ color: descColor }}>{benefit.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}